import React, { useContext, useReducer, useEffect } from "react";

import {
  Routes,
  Route,
  NavLink,
  useParams,
  useNavigate
} from "react-router-dom";

import AnswersContext from "../contexts/AnswersContext";
import useQuestions from "../hooks/useQuestions";

import Breadcrumbs from "./Breadcrumbs";
import QuestionsTab from "./QuestionsTab";
import Options from "./Options";
import Results from "./Results";

const Quiz = () => {
  const { categoryParam, topicParam } = useParams();
  const { resetAnswers } = useContext(AnswersContext);
  //const { path, url } = useRouteMatch();
  const navigate = useNavigate();

  const defaultCategory = categoryParam ? categoryParam : "";
  const defaultTopic = topicParam ? topicParam : "";

  const initialState = () => {
    return {
      index: 0,
      modulus: 1,
      shuffleGroups: false,
      shuffleQuestions: false,
      shuffleAnswers: false,
      showNumbers: true,
      showAnswers: true,
      category: defaultCategory,
      topic: defaultTopic,
      exam: false,
      finished: false,
    };
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case "next":
        return { ...state, index: state.index + 1 };
      case "previous":
        return { ...state, index: state.index - 1 };
      case "resetAnswers":
        return { ...state, index: 0 };
      case "finish":
        return { ...state, index: 0, showAnswers: true, finished: true };
      case "setIndex":
        return { ...state, index: action.payload };
      case "setModulus":
        return { ...state, modulus: action.payload };
      case "setShuffleGroups":
        return { ...state, shuffleGroups: action.payload, index: 0 };
      case "setShuffleQuestions":
        return { ...state, shuffleQuestions: action.payload, index: 0 };
      case "setShuffleAnswers":
        return { ...state, shuffleAnswers: action.payload };
      case "setShowNumbers":
        return { ...state, showNumbers: action.payload };
      case "setShowAnswers":
        return { ...state, showAnswers: action.payload };
      case "setCategory":
        return { ...state, category: action.payload, topic: "", index: 0 };
      case "setTopic":
        return { ...state, topic: action.payload, index: 0 };
      case "resetOptions":
        return initialState();
      default:
        throw new Error();
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState());

  const questions = useQuestions({
    category: state.category,
    topic: state.topic,
    shuffleGroups: state.shuffleGroups,
    shuffleQuestions: state.shuffleQuestions,
    modulus: state.modulus,
  });

  const max = (() => {
    return questions.length - 1;
  })();

  const onNext = (() => {
    return state.index < max ? () => dispatch({ type: "next" }) : undefined;
  })();

  const onPrevious = (() => {
    return state.index > 0 ? () => dispatch({ type: "previous" }) : undefined;
  })();

  const onFinish = (() => {
    return state.index === max ? () => dispatch({ type: "finish" }) : undefined;
  })();

  
  useEffect(() => {
    if (state.finished) {
      navigate("results");
    }
  }, [navigate, state.finished]);
  

  const effectiveText = state.topic ? state.topic : state.category;

  const onResetAnswers = () => {
    if (!state.finished) {
      resetAnswers(state.category, state.topic);
      dispatch({ type: "resetAnswers" });
    }
  };

  return (
    <div>
      {/*
      <Prompt
        when={Object.values(answers).some((i) => i)}
        message={(location) => {
          return location.pathname.startsWith(url)
            ? true
            : "Are you sure you want to leave the quiz? Your results will not be saved.";
        }}
      />
      */}

      <Breadcrumbs category={categoryParam} topic={topicParam} page="Quiz" />
      <nav>
        <div className="nav nav-tabs nav-fill" role="tablist">
          <NavLink
            className="nav-item nav-link"
            id="question-tab"
            to=""
            role="tab"
          >
            Quiz
          </NavLink>
          <NavLink
            className=" nav-item nav-link"
            id="options-tab"
            to="options"
            role="tab"
          >
            Options
          </NavLink>
          <NavLink
            className=" nav-item nav-link"
            id="results-tab"
            to="results"
            role="tab"
          >
            Results
          </NavLink>
        </div>
      </nav>

      <div className="tab-content">
        <Routes>
          <Route path="" element={
            <div
              className="tab-pane fade show active"
              role="tabpanel"
              id="question"
              aria-labelledby="question-tab"
            >
              <QuestionsTab
                {...state}
                questions={questions}
                onNext={onNext}
                onPrevious={onPrevious}
                onFinish={onFinish}
              />
            </div>
          }/>
          <Route path="/options" element={
            <div
              className="tab-pane fade show active"
              role="tabpanel"
              id="options"
              aria-labelledby="options-tab"
            >
              <Options
                {...state}
                dispatch={dispatch}
                categoryParam={categoryParam}
                topicParam={topicParam}
                onResetAnswers={onResetAnswers}
              />
            </div>
          }/>
          <Route path="/results" element={
            <div
              className="tab-pane fade show active"
              role="tabpanel"
              id="results"
              aria-labelledby="results-tab"
            >
              {!state.exam || state.finished ? (
                <Results questions={questions} />
              ) : (
                <main>
                  <div className="alert alert-danger" role="alert">
                    Finish exam to see results.
                  </div>
                  <div className="d-grid gap-2">
                    <button
                      className="btn btn-outline-danger"
                      type="button"
                      onClick={() => dispatch({ type: "finish" })}
                    >
                      Finish
                    </button>
                  </div>
                  <div className="d-grid gap-2">
                    <button
                      className="btn btn-outline-danger"
                      type="button"
                      disabled={state.finished}
                      onClick={() => onResetAnswers()}
                    >
                      Reset {effectiveText} Answers
                    </button>
                  </div>
                </main>
              )}
            </div>
          }/>
        </Routes>
      </div>
    </div>
  );
};

export default Quiz;
